/* Wishlist page. Handles come from Theme.wishlist (localStorage) or from a shared link (?handles=a,b).
   Product data is fetched from /products/{handle}.js and rendered with the prototype's wishlist card markup. */
(function () {
  'use strict';
  if (window.__themeWishlistPage) return;
  window.__themeWishlistPage = true;

  var cache = {};     // handle -> product json | null (not found)
  var selected = {};  // handle -> true
  var state = { filter: 'all', sort: 'recent', shared: false, sharedHandles: [] };
  var strings = {};
  var renderToken = 0;

  function root() { return document.querySelector('[data-wishlist-root]'); }
  function $(sel, ctx) { return (ctx || root() || document).querySelector(sel); }
  function esc(s) { return Theme.escape(s); }
  function fmt(tpl, map) {
    var out = tpl || '';
    Object.keys(map).forEach(function (k) { out = out.split(k).join(map[k]); });
    return out;
  }
  function loadStrings() {
    var el = $('[data-wishlist-strings]');
    try { strings = JSON.parse(el.textContent); } catch (e) { strings = {}; }
  }

  function sharedHandlesFromUrl() {
    var m = /[?&]handles=([^&]*)/.exec(window.location.search);
    if (!m) return [];
    var parts = decodeURIComponent(m[1]).split(',');
    var out = [];
    parts.forEach(function (h) {
      h = h.trim().toLowerCase();
      if (/^[a-z0-9][a-z0-9_-]*$/.test(h) && out.indexOf(h) === -1 && out.length < 50) out.push(h);
    });
    return out;
  }

  function currentHandles() {
    return state.shared ? state.sharedHandles.slice() : Theme.wishlist.all();
  }

  function fetchProduct(handle) {
    if (Object.prototype.hasOwnProperty.call(cache, handle)) return Promise.resolve(cache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return undefined; })
      .then(function (p) {
        if (p === undefined) return null; // network error: do not cache
        cache[handle] = p;
        return p;
      });
  }

  function imageUrl(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function isSingle(p) { return p.variants && p.variants.length === 1; }
  function canQuickAdd(p) { return p.available && isSingle(p) && p.variants[0].available; }

  function cardHtml(p) {
    var sel = !!selected[p.handle];
    var out = !p.available;
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var imgTag = img
      ? '<img src="' + esc(imageUrl(img, 480)) + '" srcset="' + esc(imageUrl(img, 240)) + ' 240w, ' + esc(imageUrl(img, 480)) + ' 480w, ' + esc(imageUrl(img, 720)) + ' 720w" sizes="(min-width: 1200px) 20vw, (min-width: 992px) 33vw, 50vw" alt="" loading="lazy" class="wl-img' + (out ? ' is-out' : '') + '">'
      : '';
    var price = p.price_varies ? '<span class="text-caption">' + esc(strings.from) + '</span> ' : '';
    price += '<span class="price-current-lg">' + esc(Theme.money(p.price)) + '</span>';
    var onSale = p.compare_at_price && p.compare_at_price > p.price;
    var removeLabel = fmt(strings.removeNamed, { '__TITLE__': p.title });
    var selectLabel = fmt(strings.selectNamed, { '__TITLE__': p.title });
    var h = '';
    h += '<li class="product-grid__item" data-wl-item="' + esc(p.handle) + '">';
    h += '<article class="wl-card wl-item' + (sel ? ' is-sel' : '') + '">';
    h += '<div class="wishlist-card__media">';
    h += '<a class="wishlist-card__image-link" href="' + esc(p.url) + '">' + imgTag + '</a>';
    if (!state.shared) {
      h += '<button class="wishlist-card__select" type="button" role="checkbox" aria-checked="' + sel + '" aria-label="' + esc(selectLabel) + '" data-wl-select="' + esc(p.handle) + '"><span class="wl-box' + (sel ? ' is-on' : '') + '">';
      if (sel) h += '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"></path></svg>';
      h += '</span></button>';
      h += '<button type="button" data-wl-remove="' + esc(p.handle) + '" aria-label="' + esc(removeLabel) + '" class="wl-x wishlist-card__remove-button"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"></path></svg></button>';
    }
    if (out) h += '<span class="wishlist-card__badge-out">' + esc(strings.soldOut) + '</span>';
    h += '</div>';
    h += '<div class="wishlist-card__body">';
    if (p.vendor) h += '<span class="text-caption">' + esc(p.vendor) + '</span>';
    h += '<h2 class="wishlist-card__title"><a href="' + esc(p.url) + '" class="wl-title wishlist-card__title-link">' + esc(p.title) + '</a></h2>';
    h += '<div class="wishlist-card__price-row">' + price + (onSale ? '<s class="price-was-muted">' + esc(Theme.money(p.compare_at_price)) + '</s>' : '') + '</div>';
    h += '<span class="wl-stock' + (out ? ' is-strong is-out' : '') + '">' + esc(out ? strings.outOfStock : strings.inStock) + '</span>';
    h += '<span class="flex-spacer"></span>';
    if (canQuickAdd(p)) {
      h += '<button type="button" data-wl-add="' + esc(p.handle) + '" class="wl-primary wishlist-card__add-button">' + esc(strings.addToCart) + '</button>';
    } else if (!out) {
      h += '<a href="' + esc(p.url) + '" class="wl-primary wishlist-card__add-button" style="display:flex;align-items:center;justify-content:center;text-decoration:none">' + esc(strings.chooseOptions) + '</a>';
    }
    if (!state.shared) {
      h += '<button type="button" data-wl-remove="' + esc(p.handle) + '" class="wl-rm-m">' + esc(strings.remove) + '</button>';
      h += '<div class="wishlist-card__secondary-actions"><span></span><button type="button" data-wl-remove="' + esc(p.handle) + '" class="wl-link wishlist-card__remove-link">' + esc(strings.remove) + '</button></div>';
    }
    h += '</div></article></li>';
    return h;
  }

  function sortAndFilter(products) {
    var list = products.slice();
    if (state.filter === 'stock') list = list.filter(function (p) { return p.available; });
    if (state.sort === 'low') list.sort(function (a, b) { return a.price - b.price; });
    else if (state.sort === 'high') list.sort(function (a, b) { return b.price - a.price; });
    return list;
  }

  function countText(n) {
    return n === 1 ? strings.itemOne : fmt(strings.itemMany, { '__COUNT__': n });
  }

  function updateSelectionBar() {
    var keys = Object.keys(selected);
    var bar = $('[data-wl-selection]');
    if (!bar) return;
    bar.hidden = !keys.length;
    $('[data-wl-sel-text]').textContent = keys.length === 1 ? strings.selectedOne : fmt(strings.selectedMany, { '__COUNT__': keys.length });
  }

  function addableIn(products) { return products.filter(canQuickAdd); }

  function render() {
    var r = root();
    if (!r) return;
    var token = ++renderToken;
    var handles = currentHandles();
    // drop selections that no longer exist
    Object.keys(selected).forEach(function (h) { if (handles.indexOf(h) === -1) delete selected[h]; });

    Promise.all(handles.map(fetchProduct)).then(function (products) {
      if (token !== renderToken) return;
      // newest saved first; remove handles that no longer exist in the store
      var found = [];
      handles.forEach(function (h, i) {
        if (products[i]) found.push(products[i]);
        else if (products[i] === null && cache[h] === null && !state.shared) Theme.wishlist.remove(h);
      });
      found.reverse();
      var view = sortAndFilter(found);

      $('[data-wl-count]').textContent = found.length ? countText(found.length) : '';
      var grid = $('[data-wl-grid]');
      var empty = $('[data-wl-empty]');
      var actions = $('[data-wl-actions]');
      var controls = $('[data-wl-controls]');

      grid.innerHTML = view.map(cardHtml).join('');
      grid.hidden = !view.length;
      empty.hidden = !!view.length;
      actions.hidden = !found.length;
      controls.hidden = !found.length;
      $('[data-wl-save-shared]').hidden = !state.shared;
      $('[data-wl-share]').hidden = state.shared || !found.length;
      if (!view.length && found.length) {
        $('[data-wl-empty-title]').textContent = strings.nothingMatches;
        $('[data-wl-empty-text]').textContent = '';
      }

      var addable = addableIn(view);
      var addAll = $('[data-wl-add-all]');
      addAll.textContent = fmt(strings.addAll, { '__COUNT__': addable.length });
      addAll.disabled = !addable.length;
      updateSelectionBar();
    });
  }

  function addProducts(products) {
    var items = addableIn(products);
    if (!items.length) return Promise.resolve();
    var added = 0;
    return items.reduce(function (chain, p) {
      return chain.then(function () {
        return Theme.cart.add({ id: p.variants[0].id, quantity: 1 }).then(function () { added++; });
      });
    }, Promise.resolve()).then(function () {
      Theme.toast(added === 1 ? strings.added : fmt(strings.addedMany, { '__COUNT__': added }));
    }).catch(function (err) {
      Theme.toast((err && err.message) || strings.addError, { action: false });
    });
  }

  function productsFor(handles) {
    return handles.map(function (h) { return cache[h]; }).filter(Boolean);
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(text);
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy') ? resolve() : reject(); } catch (e) { reject(e); }
      document.body.removeChild(ta);
    });
  }

  document.addEventListener('click', function (e) {
    var r = root();
    if (!r || !e.target.closest || !r.contains(e.target)) return;
    var t = e.target, b;

    if ((b = t.closest('[data-wl-remove]'))) {
      e.preventDefault();
      Theme.wishlist.remove(b.getAttribute('data-wl-remove'));
      Theme.toast(strings.removed, { action: false });
    } else if ((b = t.closest('[data-wl-select]'))) {
      var h = b.getAttribute('data-wl-select');
      if (selected[h]) delete selected[h]; else selected[h] = true;
      render();
    } else if ((b = t.closest('[data-wl-add]'))) {
      var p = cache[b.getAttribute('data-wl-add')];
      if (!p || b.disabled) return;
      b.disabled = true;
      addProducts([p]).then(function () { b.disabled = false; });
    } else if (t.closest('[data-wl-add-all]')) {
      var allBtn = t.closest('[data-wl-add-all]');
      allBtn.disabled = true;
      addProducts(sortAndFilter(productsFor(currentHandles()))).then(render);
    } else if (t.closest('[data-wl-sel-add]')) {
      addProducts(productsFor(Object.keys(selected))).then(function () { selected = {}; render(); });
    } else if (t.closest('[data-wl-sel-remove]')) {
      Object.keys(selected).forEach(function (h) { Theme.wishlist.remove(h); });
      selected = {};
      Theme.toast(strings.removed, { action: false });
    } else if (t.closest('[data-wl-sel-clear]')) {
      selected = {};
      render();
    } else if ((b = t.closest('[data-wl-filter]'))) {
      state.filter = b.getAttribute('data-wl-filter');
      Theme.qsa('[data-wl-filter]', r).forEach(function (f) {
        var on = f === b;
        f.classList.toggle('is-on', on);
        f.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      render();
    } else if (t.closest('[data-wl-share]')) {
      var handles = Theme.wishlist.all();
      if (!handles.length) return;
      var url = window.location.origin + window.location.pathname + '?handles=' + encodeURIComponent(handles.join(','));
      copyText(url).then(function () { Theme.toast(strings.linkCopied, { action: false }); }, function () { window.prompt('', url); });
    } else if (t.closest('[data-wl-save-shared]')) {
      state.sharedHandles.forEach(function (h) { if (!Theme.wishlist.has(h)) Theme.wishlist.toggle(h); });
      Theme.toast(strings.savedAll, { action: false });
      window.location.href = window.location.pathname;
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-wl-sort]')) {
      state.sort = e.target.value;
      render();
    }
  });

  document.addEventListener('theme:wishlist:changed', function () { if (root() && !state.shared) render(); });
  window.addEventListener('storage', function (e) { if (e.key === 'theme.wishlist' && root() && !state.shared) render(); });

  function init() {
    if (!root() || !window.Theme || !Theme.wishlist) return;
    loadStrings();
    state.sharedHandles = sharedHandlesFromUrl();
    state.shared = state.sharedHandles.length > 0;
    render();
  }

  function boot() {
    if (window.Theme && Theme.wishlist) init();
    else window.addEventListener('load', init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-wishlist-root]')) init();
  });
})();
